import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'productpriceorder',
})
export class ProductpriceorderPipe implements PipeTransform {

  transform(data: any, ordertype: any): any {
		if (ordertype === undefined ) {
			return data;
		} 
		else{
			 var out2=[];
        if(ordertype ==='ltoh')
          {
           out2= data.sort( function(a, b) {
              return a['price'] - b['price'];
            });
          }
          if(ordertype==='htol')
            {
             out2= data.sort( function(a, b) {
                return b['price'] - a['price'];
              });
            }
			    }
		
			return out2;
    }

}






